import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import { userModule } from './modules/user.module'
import { xarmModule } from './modules/xarm.module'
import { watchModule } from './modules/watch.module'
import { entrepriseModule } from './modules/entreprise.module'
import { periodeModule } from './modules/periode.module'
import { porteurModule } from './modules/porteur.module'
import { credentialsModule } from './modules/credentials.module'

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.sessionStorage,
    reducer (val) {
      if (!val.user.user) {
        return {}
      }
      return val
    }
  })],
  modules: {
    user: userModule,
    entreprise: entrepriseModule,
    periode: periodeModule,
    porteur: porteurModule,
    xarm: xarmModule,
    watch: watchModule,
    credentials: credentialsModule
  }
})

export default store
